import React, { useEffect, useState } from "react";
import axios from "axios";
import { Editor, EditorState, convertToRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html"; // HTML কনভার্টার
import "draft-js/dist/Draft.css"; // Draft.js styles
import { config } from "../../../config";
import Toolbar from "../../../toolbar.js"; // Import Toolbar

const apiUrl = config.apiUrl;

const CreateAboutPage = ({ onAboutPageCreated }) => {
  const [formData, setFormData] = useState({
    headline: "",
    image: null,
  });

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [editorImageParagraph, setEditorImageParagraph] = useState(
    EditorState.createEmpty()
  );
  const [editorBottomParagraph, setEditorBottomParagraph] = useState(
    EditorState.createEmpty()
  );
  const [error, setError] = useState(null);

  // Custom Style Map
const customStyleMap = {
  GREEN: {
    color: "green",
  },
};

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  useEffect(() => {
    const checkAboutPage = async () => {
      try {
        const response = await axios.get(`${apiUrl}/aboutpages`);
        if (response.data.aboutPages && response.data.aboutPages.length > 0) {
          onAboutPageCreated();
        }
      } catch (err) {
        console.error("Error checking About Page existence", err);
      }
    };

    checkAboutPage();
  }, [onAboutPageCreated]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert EditorState to HTML
    const paragraphHTML = stateToHTML(editorState.getCurrentContent());
    const imageParagraphHTML = stateToHTML(editorImageParagraph.getCurrentContent());
    const bottomParagraphHTML = stateToHTML(editorBottomParagraph.getCurrentContent());

    const data = new FormData();
    data.append("headline", formData.headline);
    data.append("paragraph", paragraphHTML);
    data.append("image", formData.image);
    data.append("imageParagraph", imageParagraphHTML);
    data.append("bottomParagraph", bottomParagraphHTML);

    try {
      await axios.post(`${apiUrl}/aboutpages`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("About Page Created Successfully!");
      onAboutPageCreated();
    } catch (err) {
      console.error("Error creating About Page", err);
      setError("An error occurred while creating the About Page.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create About Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Paragraph</label>
          <Toolbar editorState={editorState} setEditorState={setEditorState} />
          <div className="border p-2 min-h-[200px]">
            <Editor editorState={editorState} onChange={setEditorState} customStyleMap={customStyleMap} />
          </div>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image Paragraph</label>
          <Toolbar
            editorState={editorImageParagraph}
            setEditorState={setEditorImageParagraph}
          />
          <div className="border p-2 min-h-[200px]">
            <Editor
              editorState={editorImageParagraph}
              onChange={setEditorImageParagraph}
              customStyleMap={customStyleMap}
            />
          </div>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Bottom Paragraph</label>
          <Toolbar
            editorState={editorBottomParagraph}
            setEditorState={setEditorBottomParagraph}
          />
          <div className="border p-2 min-h-[200px]">
            <Editor
              editorState={editorBottomParagraph}
              onChange={setEditorBottomParagraph}
              customStyleMap={customStyleMap}
            />
          </div>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create About Page
        </button>
      </form>
    </div>
  );
};

export default CreateAboutPage;
